<div class="flex justify-between h-full items-center whitespace-nowrap">
	<p class="text-ellipsis overflow-hidden mr-3">
		<ic-support-info-banner [supportInfo]="supportInfo()" />
	</p>

	@if (supportLink) {
		<p class="ml-3 mr-3">
			<a aria-hidden="true" class="no-underline!" href="{{ supportLink | language }}" target="_blank">
				{{ "general.help_needed" | translate }}
			</a>
		</p>
	}

	<p class="ml-3">
		<i aria-hidden="true" class="fa fa-info mr-1"> </i>
		<a aria-hidden="true" class="no-underline!" href="https://into.care/privacy" target="_blank">
			{{ "general.conditions" | translate }}
		</a>

		<button class="whatsNew rounded-xs ml-3">
			<a class="text-white! no-underline!" target="_blank" [href]="whatsNewUrl | language">
				<i aria-hidden="true" class="fa fa-gift"> </i> {{ "general.whats_new" | language }}
			</a>
		</button>
	</p>
</div>
